import React, { useState } from 'react';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/webpack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faFileImage, faFilePdf } from '@fortawesome/free-solid-svg-icons';

// Set the worker source for pdfjs
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.15.0/pdf.worker.min.js`; // Use correct version

function PdfToImage() {
  const [pdfFile, setPdfFile] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePdfUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPdfFile(file);
    }
  };

  const convertPdfToImages = async (format) => {
    if (!pdfFile) return;

    setLoading(true);
    setError(null);

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const pdfData = new Uint8Array(e.target.result);
        const pdf = await getDocument({ data: pdfData }).promise;

        const pages = [];
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1 });
          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          const context = canvas.getContext('2d');
          await page.render({ canvasContext: context, viewport }).promise;
          const image = canvas.toDataURL(`image/${format}`);
          pages.push(image);
        }
        setImages(pages);
      };
      reader.readAsArrayBuffer(pdfFile);
    } catch (err) {
      setError('An error occurred while converting PDF to images.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pdf-to-image">
      <h2>PDF to Image (JPG/PNG)</h2>
      <label htmlFor="pdf-upload" className="upload-button">
        <FontAwesomeIcon icon={faFileUpload} /> Upload PDF
        <input
          id="pdf-upload"
          type="file"
          accept="application/pdf"
          onChange={handlePdfUpload}
          style={{ display: 'none' }}
        />
      </label>
      <button onClick={() => convertPdfToImages('jpeg')} disabled={loading} className="convert-button">
        <FontAwesomeIcon icon={faFileImage} /> Convert to JPG
      </button>
      <button onClick={() => convertPdfToImages('png')} disabled={loading} className="convert-button">
        <FontAwesomeIcon icon={faFilePdf} /> Convert to PNG
      </button>
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}
      <div>
        {images.map((image, index) => (
          <a key={index} href={image} download={`page_${index + 1}.${image.includes('jpeg') ? 'jpg' : 'png'}`}>
            <img src={image} alt={`Page ${index + 1}`} width="100" />
          </a>
        ))}
      </div>
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client="ca-pub-XXXXXXXXXXXXXXX"
           data-ad-slot="YYYYYYYYYYYYY"
           data-ad-format="auto"></ins>
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
    </div>
  );
}

export default PdfToImage;
